import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ModelTable from '@/components/business/crud/common/ModelTable.vue';
import { computed, inject } from 'vue';
import { HasManyFieldType } from '@/components/business/crud/interface/FieldType';
import { request } from '@/util/request';
import { WindowTool } from '@/components/common/window/WindowInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'HasMany',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const condition = computed(() => {
  return {
    [props.widget.targetPropName]: {
      [props.widget.localPrimary]: props.data[props.widget.localPrimary],
    },
  };
});
const attachCondition = computed(() => {
  return {
    [props.widget.targetPropName]: {
      $nor: {
        [props.widget.localPrimary]: props.data[props.widget.localPrimary],
      },
    },
  };
});
const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onChange(op: 'attach' | 'detach', rows?: any[]) {
  if (!rows || rows.length === 0) {
    return;
  }
  const res = await request(
    `/${props.widget.localModuleName}/${props.widget.localController}/update`,
    {
      id: props.data[props.widget.localPrimary],
      data: {
        [props.propName]: {
          [op]: rows.map((row: any) => row[props.widget.targetPrimary]),
        },
      },
    }
  );
  if (windowTool) {
    windowTool.setReturnData(true);
  }
  return res;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ModelTable, {
      status: _ctx.info.status,
      title: _ctx.info.title,
      "module-name": _ctx.widget.targetModuleName,
      "controller-name": _ctx.widget.targetController,
      "label-name": _ctx.widget.targetLabel,
      condition: condition.value,
      "attach-condition": attachCondition.value,
      "hidden-fields": [_ctx.widget.targetPropName],
      "on-change": onChange
    }, null, 8, ["status", "title", "module-name", "controller-name", "label-name", "condition", "attach-condition", "hidden-fields"])
  ]))
}
}

})